import { IModuleTrackingData } from 'homepage/types/ModuleTrackingData';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';
import { useState } from 'react';

const DEFAULT_DEBOUNCE_AMOUNT = 500;

/**
 * [useTriggerSwipeEvent]
 * Executes sending CMS module swipe event at a debounced  rate
 * @param  {IModuleTrackingData} moduleTrackingData Data to send w/ event
 * @return {Function}
 * Usage:
 *   useTriggerSwipeEvent(IModuleTrackingData)
 */
export const useTriggerSwipeEvent = (moduleTrackingData: IModuleTrackingData) => {
  const [debouncedSetScrollLeft, setDebouncedSetScrollLeft] = useState(null);

  const trackScrollEvent = () => {
    clearTimeout(debouncedSetScrollLeft);
    setDebouncedSetScrollLeft(
      setTimeout(() => {
        sendTrackingEvent('CMS_MODULE_SWIPE', { ...moduleTrackingData });
      }, DEFAULT_DEBOUNCE_AMOUNT),
    );
  };

  return {
    trackScrollEvent,
  };
};

export default useTriggerSwipeEvent;
